/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

import TOC from '@ember/component/template-only';

export interface ISkusPartTypeFilterDefinitionArgs {
  skuId?: string;
  horizontalPosition?: 'left' | 'right' | 'auto';
  beforeQuery?: (query: IJsonApiQuery) => IJsonApiQuery;
}
const FiltersSkusPartTypeFilterComponent = TOC<ISkusPartTypeFilterDefinitionArgs>();
export default FiltersSkusPartTypeFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::SkusPartTypeFilter': typeof FiltersSkusPartTypeFilterComponent;
    'filters/skus-part-type-filter': typeof FiltersSkusPartTypeFilterComponent;
  }
}
